export const recentPosts = [
  {
    "id": 26,
    "site": "cda",
    "title": "Week of AI Gallery",
    "category": "doodle",
    "subCategory": [
      "coffee",
      "sketches",
      "AI"
    ],
    "description": "New AI is turning my work into masterpieces...",
    "fullText": "<p>I've made a lot of drawings, around 2,000 of them. But every time I put them into the AI and say \"Make my art a Masterpiece\" it has never told me that my art is already a masterpiece.</p> <p>But it's a lot of fun to see what AI does. Sometimes I tell the machine to focus on one part of the composition. Sometimes it makes something more like a rembrant, sometimes picaso, sometimes it does a less well known style.</p><p>I'm thinking of making a site that will be a gallery of the very best AI pieces if I can get some other artists to join up in this adventure. Just email me at CoffeeDoodleArt@gmail.com if you want to be a part of this epic journey and once we get a bunch of people interested we can start a new site for our work!</p>",
    "authorName": "Lily and Michael",
    "authorAvatar": "/assets/images/lilymichael2.png",
    "createdAt": "May 10, 2025",
    "cover": "/assets/images/CDA26-thumb.png",
    "duration": "18 pieces",
    "images": [
      "/assets/cda/25.05.10/01.M.05.10.25%20Floating%20Cactus.png",
      "/assets/cda/25.05.10/02.M.05.10.25%20Bird%20Fish%20and%20Robot.png",
      "/assets/cda/25.05.10/03.M.05.10.25%20Demon.png",
      "/assets/cda/25.05.10/04.M.05.10.25%20Kronos.png",
      "/assets/cda/25.05.10/05.M.05.10.25%20Mind%20Games.png",
      "/assets/cda/25.05.10/06.M.05.10.25%20Nigel.png",
      "/assets/cda/25.05.10/07.M.05.10.25%20Puzzle%20Snake.png",
      "/assets/cda/25.05.10/08.M.05.10.25%20Still%20On%20the%20Table.png",
      "/assets/cda/25.05.10/09.M.05.10.25%20Swim%20Meet.png",
      "/assets/cda/25.05.10/10.M.05.10.25%20Tourist.png",
      "/assets/cda/25.05.10/11.M.05.10.25%20Deadpool.png",
      "/assets/cda/25.05.10/12.M.05.10.25%20Moon%20Roof.png",
      "/assets/cda/25.05.10/13.M.05.10.25%20Made%20of%20Bricks.jpg",
      "/assets/cda/25.05.10/14.M.05.10.25%20Melted.png",
      "/assets/cda/25.05.10/15.M.05.10.25%20Holy%20Gruboli.jpg",
      "/assets/cda/25.05.10/16.M.05.10.25%20Noise.jpg",
      "/assets/cda/25.05.10/17.M.05.10.25%20Brainzilla.png",
      "/assets/cda/25.05.10/18.M.05.10.25%20Grenjarnia%20.png"
    ],
    "ctaButtons": [
      {
        "platformLogo": "/assets/images/cta-email.png",
        "titleText": "Email Us To Buy a Print",
        "priceTag": "$30 Per Print",
        "appIcon": "/assets/images/CDALogo.png",
        "linkTo": "mailto:coffeedoodleart@gmail.com?subject=I'd like to buy one of your prints!"
      }
    ]
  },
  {
    "id": 13,
    "site": "matchyverse",
    "title": "Rewriting the Universe",
    "category": "design",
    "subCategory": [
      "game",
      "matchy star",
      "gamedev"
    ],
    "description": "Big changes are coming to the Matchyverse™...",
    "fullText": "<p>We've been reworking EVERYTHING about Matchy Star. Since we are basically in stealth mode, there is no reason not to make this game the most fun matching game ever made.</p><p>Some of the stuff we've been working on.</p><ul><li>Items are unique and interesting.</li><li>Chill ballast system instead of making the ships move fast and stress you out.</li><li>Arc Chart screen where you can rotate the Alpha Galaxy to select your course.</li><li>Stats and unlock progress.</li><li>More levels and improved progression curve.</li></ul><p>Also we are defining the universe more, and creating some AI animations for various characters and locations in the Universe!</p>",
    "authorName": "Michael Silverman",
    "authorLink": "https://michaelplzno.com",
    "authorAvatar": "/assets/images/matchyverse-signature-michael.webp",
    "createdAt": "April 23, 2025",
    "cover": "/assets/images/Zazz_Lair_Thumb.gif",
    "ctaButtons": [
      {
        "platformLogo": "/assets/images/discord.png",
        "titleText": "Join Our Discord Chat",
        "priceTag": "Learn More!",
        "appIcon": "/assets/images/MatchyOGIcon.png",
        "linkTo": "https://discord.silverwaregames.com"
      }
    ]
  },
  {
    "id": 17,
    "site": "swg",
    "title": "New Icon for Hundred Bullets™",
    "category": "game",
    "subCategory": [
      "XBOX",
      "game",
      "icon"
    ],
    "description": "Master the great doubt, dodge your own bullets...",
    "fullText": "<p>A new icon for Hundred Bullets™. The Zen Goddess is now cleaner and more polished.</p><figure><img src=\"/assets/images/HB_Alternate.png\" alt=\"Alternate\" /><figcaption>Alternate Icon</figcaption></figure><p>It took many many iterations and we may still redesign it yet again. But we are happy with the new look. Thinking about primary colors, the vastness of space and the mind, mandalas, and all kinds of deep thoughts.</p><p>Check out a little animation of the new icon <a href=\"https://youtube.com/shorts/-a7t3g_6hNc\">right here!</a></p>",
    "authorName": "Michael Silverman",
    "authorLink": "https://michaelplzno.com",
    "authorAvatar": "/assets/images/author.jpg",
    "createdAt": "April 22, 2025",
    "cover": "/assets/images/hundred_bullets_thumb.gif",
    "ctaButtons": [
      {
        "platformLogo": "/assets/images/xbox-app.png",
        "titleText": "Buy Hundred Bullets on XBOX Now",
        "priceTag": "$9.99",
        "appIcon": "/assets/images/hundredbullets-icon.png",
        "linkTo": "https://www.xbox.com/en-us/games/store/hundred-bullets/9p7bw4gn1lr0"
      }
    ]
  },
  {
    "id": 7,
    "site": "plzno",
    "title": "Compsci Guy: 3 Body",
    "category": "youtube",
    "subCategory": [
      "math",
      "compsi",
      "netflix"
    ],
    "description": "Analasys of popular netflix show 3 body problem...",
    "fullText": "<a href=\"https://www.youtube.com/watch?v=BbPE4R6KG_A\"> Watch on youtube! </a>",
    "authorName": "michaelplzno",
    "authorAvatar": "/assets/images/plzno.jpg",
    "createdAt": "Jun 23, 2024",
    "cover": "/assets/images/3BodyThumb.gif",
    "link": "https://www.youtube.com/watch?v=BbPE4R6KG_A",
    "duration": "6min"
  }
];